import { useEffect, useState } from 'react'
import * as store from '@store'
import { useWireState } from '@forminator/react-wire'
import useNavigate from '@/hook/useNavigate'
import { UpsertCollection } from '../collection/UpsertCollection'
import { UpsertRunsheet } from '../tract/UpsertRunsheet'
import { UpsertTract } from '../tract/UpsertTract'
import { TAB_TYPE_DEED } from '@/constants'

export const STEPS = {
    COLLECTION: 'collection',
    RUNSHEET: 'runsheet',
    TRACT: 'tract',
}

const CollectionRunsheetPersistFlow = ({
    setEditDialogOpen,
    initialData,
    initialStep,
}) => {
    
    const navigate = useNavigate()
    const [step, setStep] = useState(initialStep)
    const [createRunsheetAfterwards, setCreateRunsheetAfterwards] = useState(false)
    const [createTractAfterwards, setCreateTractAfterwards] = useState(false)
    const [collection, setCollection] = useState(null)
    const [selectedRunsheet, setSelectedRunsheet] = useWireState(store.currentRunsheet)
    
    const stepForwardFromCollection = () => {
        setStep(createRunsheetAfterwards ? STEPS.RUNSHEET : null)
    }
    
    const stepForwardFromRunsheet = () => {
        setStep(createTractAfterwards ? STEPS.TRACT : null)
    }
    
    useEffect(() => {
        setCreateTractAfterwards(createRunsheetAfterwards)
    }, [createRunsheetAfterwards])
    
    useEffect(() => {
        
        if (step) return
        
        setEditDialogOpen(false)
        // Collection or runsheet was created, not edited, so auto redirect to the new collection
        if (!initialData)
            if (collection && initialStep === STEPS.COLLECTION)
                navigate(`/collection/${collection.id}/browse`)
            else if (selectedRunsheet && initialStep === STEPS.RUNSHEET)
                navigate(`/runsheet/${selectedRunsheet?.id}`)
        
    }, [collection, initialData, step])
    
    return (<>
        
        {step === STEPS.COLLECTION &&
            <UpsertCollection id="create-collection"
                showAdd={step === STEPS.COLLECTION}
                showHideAdd={() => setStep(null)}
                createRunsheetAfterwards={createRunsheetAfterwards}
                setCreateRunsheetAfterwards={setCreateRunsheetAfterwards}
                editCollection={initialData}
                onSuccess={col => {
                    setCollection(col)
                    stepForwardFromCollection()
                }} />
        }
        
        {step === STEPS.RUNSHEET &&
            <UpsertRunsheet
                id="create-runsheet"
                showAdd={step === STEPS.RUNSHEET}
                showHideAdd={() => setStep(null)}
                createTractAfterwards={createTractAfterwards}
                setCreateTractAfterwards={setCreateTractAfterwards}
                closeOnSave={!!initialData}
                redirect={!createTractAfterwards}
                initial={initialData}
                initialName={collection?.name || ''}
                runsheetSaved={runsheet => {
                    setSelectedRunsheet(runsheet)
                    stepForwardFromRunsheet()
                }}/>
        }
        
        {step === STEPS.TRACT &&
            <UpsertTract
                id="create-tract"
                showAdd={step === STEPS.TRACT}
                showHideAdd={() => setStep(null)}
                runsheetId={selectedRunsheet?.id} 
                initialName={collection?.name || ''}
                shouldAssign={true}
                ownershipType={TAB_TYPE_DEED}/>
        }
    
    </>)
    
}

export default CollectionRunsheetPersistFlow
